import Dependent from './Dependent';
import CookiesService from '../shared/CookiesService';
import apiEncrypt from '../shared/Encrypt';
import apiDecrypt from '../shared/Decrypt';

class MemberSummary {
  constructor() {
    this.oid = '';
    this.memberID = '';
    this.alternateID1 = '';
    this.alternateID2 = '';
    this.certificateNumber = '';
    this.socialSecurityNumber = '';
    this.memberSeqID = '';
    this.memberType = '';
    this.birthDate = '';
    this.gender = '';
    this.firstName = '';
    this.middleName = '';
    this.lastName = '';
    this.numberofDependents = 0;
    this.fetched = false;
    this.memberSummaryResponse = null;
    this.sidemenuPermissions = false;
    this.loggedInMemberType = '';
    this.loggedInUserOID = '';
    this.suffix = '';
    this.title = '';
    this.memberOid = [];
    this.selectedMemType = [];
  }

  getMemberOID() {
    this.oid = apiDecrypt(CookiesService.get('MemberOID'));
    return this.oid;
  }

  setMemberOID(oid) {
    CookiesService.set('MemberOID', apiEncrypt(oid));
    this.oid = oid;
  }

  getMemberSummaryResponse() {
    return this.memberSummaryResponse;
  }

  setMemberSummaryResponse(memberSummaryResponse) {
    this.memberSummaryResponse = memberSummaryResponse;
  }

  getMemberID() {
    this.memberID = localStorage.getItem('Member ID');
    return this.memberID;
  }

  setMemberID(memberID) {
    localStorage.setItem('Member ID', memberID);
    this.memberID = memberID;
  }

  getSideMenuPermissions() {
    const sideMenu = CookiesService.get('sideMenuPermissions');
    this.sidemenuPermissions = sideMenu;
    return this.sidemenuPermissions;
  }

  setSideMenuPermissions(sidemenuPermissions) {
    CookiesService.set('sideMenuPermissions', sidemenuPermissions);
    this.sidemenuPermissions = sidemenuPermissions;
  }

  getAlternateID1() {
    return this.alternateID1;
  }

  setAlternateID1(alternateID1) {
    this.alternateID1 = alternateID1;
  }

  getAlternateID2() {
    return this.alternateID2;
  }

  setAlternateID2(alternateID2) {
    this.alternateID2 = alternateID2;
  }

  getCertificateNumber() {
    return this.certificateNumber;
  }

  setCertificateNumber(certificateNumber) {
    this.certificateNumber = certificateNumber;
  }

  getSocialSecurityNumber() {
    return this.socialSecurityNumber;
  }

  setSocialSecurityNumber(socialSecurityNumber) {
    this.socialSecurityNumber = socialSecurityNumber;
  }

  getMemberSeqID() {
    return this.memberSeqID;
  }

  setMemberSeqID(memberSeqID) {
    this.memberSeqID = memberSeqID;
  }

  getMemberType() {
    this.memberType = apiDecrypt(CookiesService.get('MemberType'));
    return this.memberType;
  }

  setMemberType(memberType) {
    CookiesService.set('MemberType', apiEncrypt(memberType));
    this.memberType = memberType;
  }

  getBirthDate() {
    return this.birthDate;
  }

  setBirthDate(birthDate) {
    this.birthDate = birthDate;
  }

  getGender() {
    return this.gender;
  }

  setGender(gender) {
    this.gender = gender;
  }

  resetFirstName() {
    this.firstName = '';
    localStorage.removeItem('MemberFirstName');
  }

  getFirstName() {
    this.firstName = localStorage.getItem('MemberFirstName');
    return this.firstName;
  }

  setFirstName(firstName) {
    localStorage.setItem('MemberFirstName', firstName);
    this.firstName = firstName;
  }

  getLastName() {
    this.lastName = localStorage.getItem('MemberLastName');
    return this.lastName;
  }

  setLastName(lastName) {
    localStorage.setItem('MemberLastName', lastName);
    this.lastName = lastName;
  }

  getMemberTitle() {
    this.title = localStorage.getItem('MemberTitle');
    return this.title;
  }

  setMemberTitle(memberTitle) {
    localStorage.setItem('MemberTitle', memberTitle);
    this.title = memberTitle;
  }

  getNumberOfDependents() {
    return this.numberofDependents;
  }

  setNumberOfDependents(numberofDependents) {
    this.numberofDependents = numberofDependents;
  }

  getLoggedInMemberType() {
    return this.loggedInMemberType;
  }

  setLoggedInMemberType(loggedInMemberType) {
    this.loggedInMemberType = loggedInMemberType;
  }

  getLoggedInUserOID() {
    return this.loggedInUserOID;
  }

  setLoggedInUserOID(loggedInUserOID) {
    this.loggedInUserOID = loggedInUserOID;
  }

  getSelectedMemOID(iIndex) {
    let memOid = [];
    memOid = JSON.parse(apiDecrypt(CookiesService.get('MemOidArray')));
    this.memberOid[iIndex] = memOid[iIndex];
    return this.memberOid[iIndex];
  }

  setSelectedMemOID(iIndex, oid) {
    this.memberOid[iIndex] = oid;
    CookiesService.set(
      'MemOidArray',
      apiEncrypt(JSON.stringify(this.memberOid)),
    );
  }

  getSelectedMemType(iIndex) {
    let memType = [];
    memType = JSON.parse(apiDecrypt(CookiesService.get('MemTypeArray')));
    this.selectedMemType[iIndex] = memType[iIndex];
    return this.selectedMemType[iIndex];
  }

  setSelectedMemType(iIndex, memType) {
    this.selectedMemType[iIndex] = memType;
    CookiesService.set(
      'MemTypeArray',
      apiEncrypt(JSON.stringify(this.selectedMemType)),
    );
  }

  parseMemberSummary() {
    let iIndex = 0;

    const memberSummaryResp = this.getMemberSummaryResponse();

    this.setMemberOID(memberSummaryResp.Response.Member.OID);
    this.setSelectedMemOID(iIndex, memberSummaryResp.Response.Member.OID);
    this.setMemberID(memberSummaryResp.Response.Member.MemberID);
    this.setFirstName(memberSummaryResp.Response.Member.FirstName);
    this.setLastName(memberSummaryResp.Response.Member.LastName);
    this.setBirthDate(memberSummaryResp.Response.Member.BirthDate);
    this.setMemberType(memberSummaryResp.Response.MemberType);
    this.setSelectedMemType(iIndex, memberSummaryResp.Response.MemberType);
    this.setLoggedInUserOID(memberSummaryResp.Response.Member.LoggedInUserOID);
    this.setLoggedInMemberType(
      memberSummaryResp.Response.Member.LoggedInMemberType,
    );

    if (memberSummaryResp.Response.Member.MemberSeqID === null)
      //equals null
      this.setMemberSeqID(0);
    else this.setMemberSeqID(memberSummaryResp.Response.Member.MemberSeqID);
    console.log(this.getMemberSeqID());

    if (
      memberSummaryResp.Response.Member.NumberOfDependents === null ||
      memberSummaryResp.Response.Member.NumberOfDependents === 0
    )
      //equals null
      this.setNumberOfDependents(0);
    else
      this.setNumberOfDependents(
        memberSummaryResp.Response.Member.NumberOfDependents,
      );
    console.log(this.getMemberID());
    console.log('No of dependents dashboard: ', this.getNumberOfDependents());

    if (this.getNumberOfDependents() > 0)
      for (iIndex = 0; iIndex < this.getNumberOfDependents(); iIndex++) {
        Dependent.setMemberOID(
          iIndex,
          memberSummaryResp.Response.Member.DependentsInfo[iIndex].OID,
        );
        this.setSelectedMemOID(
          iIndex + 1,
          memberSummaryResp.Response.Member.DependentsInfo[iIndex].OID,
        );
        this.setSelectedMemType(iIndex + 1, 'Dependent');
        Dependent.setMemberSeqID(
          iIndex,
          memberSummaryResp.Response.Member.DependentsInfo[iIndex].MemberSeqID,
        );
        Dependent.setFirstName(
          iIndex,
          memberSummaryResp.Response.Member.DependentsInfo[iIndex].FirstName,
        );
        Dependent.setLastName(
          iIndex,
          memberSummaryResp.Response.Member.DependentsInfo[iIndex].LastName,
        );
        Dependent.setMiddleName(
          iIndex,
          memberSummaryResp.Response.Member.DependentsInfo[iIndex].MiddleName,
        );
        Dependent.setDependentLink(
          iIndex,
          memberSummaryResp.Response.Member.DependentsInfo[iIndex]
            .DependentLink,
        );
        Dependent.setRelationshipToMember(
          iIndex,
          memberSummaryResp.Response.Member.DependentsInfo[iIndex]
            .RelationshipToMember,
        );
      }
  }

  resetMemberSummary() {
    this.oid = '';
    this.memberID = '';
    this.alternateID1 = '';
    this.alternateID2 = '';
    this.certificateNumber = '';
    this.socialSecurityNumber = '';
    this.memberSeqID = '';
    this.memberType = '';
    this.birthDate = '';
    this.gender = '';
    this.firstName = '';
    this.middleName = '';
    this.lastName = '';
    this.numberofDependents = 0;
    this.fetched = false;
    this.memberSummaryResponse = null;
    this.sidemenuPermissions = false;
    this.loggedInMemberType = '';
    this.loggedInUserOID = '';
    this.suffix = '';
    this.title = '';
  }
}

export default new MemberSummary();
